import { render, staticRenderFns } from "./GImage.vue?vue&type=template&id=45ce1285&"
import script from "./GImage.vue?vue&type=script&lang=js&"
export * from "./GImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports